export const GET_AIDS = "GET_AIDS";
export const FILTER_AIDS = "FILTER_AIDS";
export const ADD_AID = "ADD_AID";
export const EDIT_AID = "EDIT_AID";
export const GET_AID = "GET_AID";
export const RESET_AID = "RESET_AID";
export const AIDS_ERROR = "AIDS_ERROR";
